import { REQUEST_URL } from "../constants";
import { PaginationQueryModel, AgentInputModel } from "../models";
import { RequestUtil } from "../utils";

export const AgentService = {
  filterAgents,
  createAgent,
  updateAgent,
  deleteAgent
};

function filterAgents(query: PaginationQueryModel & { searchValue?: string } & { status?: string[] } = {}) {
  const url = REQUEST_URL.FILTER_AGENT;

  return RequestUtil.get({ url, query: query });
}

function createAgent(data: AgentInputModel) {
  const url = REQUEST_URL.CREATE_AGENT;

  return RequestUtil.post({ url, data });
}

function updateAgent(agentId: string, data: AgentInputModel) {
  const url = REQUEST_URL.UPDATE_AGENT.replace("{AGENT_ID}", agentId);

  return RequestUtil.put({ url, data });
}

function deleteAgent(agentId: string) {
  const url = REQUEST_URL.DELETE_AGENT.replace("{AGENT_ID}", agentId);

  return RequestUtil.delete({ url });
}